import type React from 'react';

import st from './EstimationError.module.sass';

interface EstimationErrorProps {
  error?: string;
}

function EstimationError({
  error = undefined,
}: EstimationErrorProps): React.JSX.Element | null {
  if (!error) return null;
  return (
    <div className={st.Error}>
      {error}
    </div>
  );
}

export { EstimationError };
